import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import Modal from './Modal';
import Button from '../Button';
import H4Title from '../H4Title';

type Props = {
  isOpen: boolean,
  onClose: () => void,
  titleI18nKey: string,
  cancelButtonI18nKey?: string,
  confirmationButtonI18nKey?: string,
  subtTitleI18nKey: string,
  children?: ReactNode,
  onConfirm: () => void,
  onCancel?: () => void,
  confirmeDisabled: boolean,
  small?: boolean,
  entite?: string,
  isLoading?: boolean,
};

type State = {
  isBlocked: boolean,
  confimationModalOpen: boolean,
};

class ConfirmationModal extends React.PureComponent<Props> {
  render(): ReactNode {
    return (
      <Modal isOpen={this.props.isOpen} onClose={this.props.onClose} className={this.props.small ? 'small' : ''}>
        <div className="confirmation-modal">
          <H4Title>
            <Translate value={this.props.titleI18nKey} />
          </H4Title>
          <h5>
            <Translate
              value={this.props.subtTitleI18nKey}
              entite={this.props.entite}
              dangerousHTML
            />
          </h5>
          <div className="confimation-modal-content">
            {this.props.children}
          </div>
          <div className="button-container">
            <Button
              type="third"
              onClick={this.props.onCancel || this.props.onClose}
              i18nKey={this.props.cancelButtonI18nKey || 'actions.CANCEL'}
            />
            <Button
              disabled={this.props.confirmeDisabled}
              type="primary"
              isLoading={this.props.isLoading}
              onClick={this.props.onConfirm}
              i18nKey={this.props.confirmationButtonI18nKey || 'actions.CONFIRM'}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default ConfirmationModal;
